import { IGAEvent, IGAExceptions, IGAPageView } from '..';

declare const window: any;

class GoogleAnalytics4ServiceClass {

    trackingId: string;
    trackCustomEvents: boolean;

    constructor() {
        window['dataLayer'] = window['dataLayer'] || [];
        window['gtag'] = function () {
            window['dataLayer'].push(arguments);
        };
    }
    /**
     * Method to initialize GA
     * @param trackingId
     * @param trackPageViews
     * @param trackWindowErrors
     * @param trackCustomEvents
     */
    initialize(trackingId, trackPageViews = true, trackWindowErrors = true, trackCustomEvents = true, customDimensions = {}) {
        this.trackingId = trackingId;
        this.trackCustomEvents = trackCustomEvents;
        const script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackingId;
        document.head.appendChild(script);
        script.onload = () => {
            window['gtag']('js', new Date());
            window['gtag']('config', this.trackingId);
        };
        if (trackWindowErrors) {
            this.trackWindowErrors();
        }
        if (!trackPageViews) {
            const obj = Object.assign({
                'send_page_view': false
            }, customDimensions);
            window['gtag']('config', this.trackingId, obj);
        }
    }
    /** Manually send page view
     * @pageViewObj
    */
    sendPageView(pageViewObj: IGAPageView) {
        window['gtag']('event', 'page_view', {
            page_title: pageViewObj.pageTitle,
            page_path: pageViewObj.pagePath,
            page_location: pageViewObj.pageLocation
        });
    }
    /**
     * Method to add extra context to all RUM events collected from your application
     * @param contextList
     */
    addGlobalContext(obj: any) {
        window['gtag']('config', this.trackingId, obj);
    }
    /**
     * Add custom event
     * @param event
     */
    trackEvent(event: IGAEvent) {
        if (this.trackCustomEvents) {
            window['gtag']('event', event.eventName, event.eventParams);
        }
    }

    /**
     * Capture exception at window level
     */
    trackWindowErrors() {
        window.onerror = (message, source, lineNo, columnNo, error) => {
            const messageObj = [
                'Message: ' + message,
                'URL: ' + source,
                'Line: ' + lineNo,
                'Column: ' + columnNo,
                'Error object: ' + JSON.stringify(error)
            ].join(' - ');
            window['gtag']('event', 'exception', {
                description: messageObj,
                fatal: false
            });
        };
    }
    /**
    * Capture exception
    *  @error
    */
    trackErrors(error: IGAExceptions) {
        window['gtag']('event', 'exception', {
            description: error.description,
            fatal: error.fatal
        });
    }
}

export const GoogleAnalytics4Service = new GoogleAnalytics4ServiceClass();
